import Backbone, {ViewOptions} from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import TimerList from 'notebook/protocols/timers/TimerList';
import TimerStore from 'notebook/protocols/timers/TimerStore';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

class TimerView extends Backbone.View<Backbone.Model> {
  initialize(options: ViewOptions<Backbone.Model>): void {
    this.render = this.render.bind(this);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    TimerStore.addChangeListener(this.render);
  }

  remove(): Backbone.View<Backbone.Model> {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    TimerStore.removeChangeListener(this.render);
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }

  render(): this {
    const component = <TimerList {...TimerStore.getState()} />;
    renderToDOM(component, this.el);
    return this;
  }
}

export default TimerView;
